
import {Component, Vue} from 'vue-property-decorator';
@Component
export default class LanguageSwitch extends Vue {
  select(language: string): void {
    if (language === this.$i18n.locale) return;
    localStorage.setItem('pult-language', language);
    window.location.reload();
  }
}
